export const VERSION = {
  PROD: 'V. 3.3.0',
  QA: 'V. 3.25.3 (QA)',
}
